import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SubPageNav from "../components/SubPageNav";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-brand-bg py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <SubPageNav />
        <h1 className="font-heading text-4xl sm:text-5xl font-bold mb-8">Impressum</h1>

        <div className="space-y-6 text-brand-muted leading-relaxed">
          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-2">Angaben gemäß § 5 TMG</h2>
            <p className="mt-3">
              Trendgut (Einzelunternehmen)<br />
              Inhaber: Menal Zeynal Akkurt<br />
              handelnd unter der Marke „Strombaron"<br />
              Westring 117<br />
              32051 Herford
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-6">Kontakt</h2>
            <p className="mt-3">
              Telefon: <a href="tel:+4917282465640" className="text-brand-text hover:text-brand-energyHover underline">0172 8246564</a><br />
              E-Mail: <a href="mailto:info@strombaron.de" className="text-brand-text hover:text-brand-energyHover underline">info@strombaron.de</a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-6">Tätigkeit</h2>
            <p className="mt-3">
              Selbstständige Tätigkeit als Handelsvertreter im Sinne des § 84 HGB.
            </p>
            <p className="mt-3">
              Ich bin als unabhängiger Handelsvertreter im Auftrag der Teleson AG tätig und vermittle
              Strom- und Gastarife für Privat- und Geschäftskunden.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-6">Hinweis zur Vermittlung</h2>
            <p className="mt-3">Ich bin kein Energieversorger.</p>
            <p className="mt-3">
              Verträge kommen ausschließlich zwischen dem Kunden und dem jeweiligen
              Energieversorgungsunternehmen zustande.
            </p>
            <p className="mt-3">
              Die Vermittlung erfolgt im Auftrag und unter Einhaltung der Rahmenbedingungen der:<br />
              <span className="text-brand-text font-semibold">Teleson AG</span><br />
              <a href="https://www.teleson.de/" target="_blank" rel="noopener noreferrer" className="text-brand-text hover:text-brand-energyHover underline">
                https://www.teleson.de/
              </a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-6">Umsatzsteuer</h2>
            <p className="mt-3">
              Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:<br />
              <span className="text-brand-text font-semibold">DE456686312</span>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-6">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p className="mt-3">
              Menal Zeynal Akkurt<br />
              Westring 117<br />
              32051 Herford
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-6">Streitschlichtung</h2>
            <p className="mt-3">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-brand-text hover:text-brand-energyHover underline">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="mt-3">
              Ich bin nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
